import React from 'react';
import styled from 'styled-components';
import { Button } from '../../wag-react/next-components/button';
import { scrollToViewByCoords } from '../../utils/scrollToView';
import { HOMEPAGE_FORM_SECTION } from '../../constants';
interface GetStartedButtonProps {
  width?: string;
}
const StyledButton = styled(Button)`
  border-radius: 24px;
  background: var(--Fill-wagBlue, #2866D3);
  width: 100%;
  max-width: 340px;
  height: 48px;
  font-family: var(--Font-Family-Font, "Hero New");
  color: var(--Text-white, #FFF);
  text-align: center;
  font-size: var(--Font-Size-Caption, 14px);
  font-style: normal;
  font-weight: 700;
  line-height: var(--Line-Height-Caption, 20px);
  letter-spacing: var(--Letter-Spacing-0, 0px);
`;
export const GetStartedButton: React.FC<GetStartedButtonProps> = ({
  width = '340px'
}) => {
  const handleClick = () => {
    // get the scroll position of the homepage form section
    const formSection = document.getElementById(HOMEPAGE_FORM_SECTION);
    const scrollPosition = formSection?.offsetTop;
    scrollToViewByCoords({
      top: scrollPosition - 60,
      left: 0,
      behavior: 'smooth'
    });
  };
  return <StyledButton onClick={handleClick} variant="contained" style={{
    maxWidth: width,
    fontFamily: '"Hero New", sans-serif',
    fontWeight: 700
  }} data-sentry-element="StyledButton" data-sentry-component="GetStartedButton" data-sentry-source-file="index.tsx">
      Get started
    </StyledButton>;
};
export default GetStartedButton;